import { useRecoilValue } from "recoil";

import { firebaseStore } from "store/firebaseStore";

export const useFirebaseRecoilValue = () => {
  return useRecoilValue(firebaseStore);
};
